/**
 * Role TIERS - the only thing the app reads from a role string.
 *
 * Mirrors roleTier in shipengine_api/src/modules/company-roles/menu-catalog.ts.
 * Below the tier, what a person may open, do and see comes from their role's
 * permissions (`hasMenuPermission`, `hasAction`, `hasScope`), never from which
 * role it is: Facility User and Vertical are built-in roles like any other.
 */
export type RoleTier = 'super_admin' | 'company_admin' | 'sub_admin' | 'member';

export const roleTier = (role: string | null | undefined): RoleTier =>
  role === 'super_admin'
    ? 'super_admin'
    : role === 'company_admin'
      ? 'company_admin'
      : role === 'sub_admin'
        ? 'sub_admin'
        : 'member';

/** Company admins and super admins: every permission, no data scope. */
export const isFullAccessRole = (role: string | null | undefined): boolean => {
  const tier = roleTier(role);
  return tier === 'super_admin' || tier === 'company_admin';
};

/** Data scope: confined to the facilities assigned to the person. */
export const FACILITY_SCOPE = 'scope.assigned_facilities';
